import React, { useContext, useEffect, useState } from 'react';
import { AppContext } from "../../context/ContextProvider";
import { useTranslation } from 'react-i18next'

const OnceFooter = () => {
  const { getAgentCodekey } = useContext(AppContext);
  const agent = getAgentCodekey() || null;
  const { t } = useTranslation()

  return (
    <footer>
      <div className="tp-footer__area black-bg">
        <div className="tp-footer">
          {/* <!-- main-footer start  --> */}
          <div className="tp-footer__main">
            <div className="container">
              <div className="tp-footer-border pt-30">
                <div className="row">
                  <div className="col-lg-4 col-md-6">
                    <div className="tp-footer__widget tp-footer__2 footer-col-2-1 pb-30">
                      <div className="footer-logo mb-30" style={{ width: '220px' }}>
                        <a href="#"><img src="/assets/img/logo/logo.png" alt="" /></a>
                      </div>
                      <h3 className="tp-footer__widget-title text-white">{t('slogan_1')}</h3>
                      <span>{t('slogan_2')}</span>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 offset-lg-4">
                    <div className="tp-footer__widget tp-footer__2 pb-30 text-start text-lg-end">
                      <a
                        href="https://dbdregistered.dbd.go.th/api/public/shopinfo?param=01ECCBE6C7911A80632132FF3F7B201CD9DAD41B5D481CCAFB4BD997A3C95FE2"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          src="https://dbdregistered.dbd.go.th/api/public/banner?param=01ECCBE6C7911A80632132FF3F7B201CD9DAD41B5D481CCAFB4BD997A3C95FE2"
                          alt="DBD Registered"
                          loading="lazy"
                          style={{ width: '100%', maxWidth: '160px', height: 'auto' }}
                        />
                      </a>
                    </div>
                  </div>

                  {/* <div className="col-lg-4 col-md-6">
                    <div className="tp-footer__widget tp-footer__2 footer-col-2-2 pb-30">
                      <h3 className="tp-footer__widget-title text-white">Our Location</h3>
                      <ul>
                        <li><a href="#">ลพบุรี</a></li>
                        <li><a href="#">กรุงเทพมหานคร</a></li>
                      </ul>
                    </div>
                  </div> */}

                  {/* <div className="col-lg-4 col-md-6">
                    <div className="tp-footer__widget tp-footer__2 footer-col-2-3 pb-30">
                      <h3 className="tp-footer__widget-title text-white">โทร/Line ID</h3>
                      <ul> */}
                  {/* <li><a href="#">09-5935-4624</a></li> */}
                  {/* <li><a href="#">บริษัท เพชรยอดมงกุฏ จำกัด</a></li>
                        {/* <li><a href="#">บริษัท เพชรยอดมงกุฏ จำกัด</a></li>
                        <li><a href="#">ตำบลเขาพระงาม อำเภอเมือง จังหวัดลพบุรี</a></li> */}
                  {/* <li><a href="tel:+66911205531">09-9999-9999</a></li>
                        <li><a href="mailto:support@example.com">support@onceinmemory.com</a></li> */}
                  {/* <li><span> Office Hours: 8AM - 6PM</span></li>
                        <li><span> Open Everyday</span></li> */}
                  {/* </ul>
                    </div>
                  </div> */}
                  {/* <div className="col-lg-3 col-md-6 ">
                    <div className="tp-footer__widget tp-footer__2 footer-col-2-4  pb-30">
                      <h3 className="tp-footer__widget-title text-white">Newslatter</h3>
                      <div className="footer-form-3 mb-30">
                        <form>
                          <input type="email" placeholder="Enter your mail" />
                          <button type="submit">Subscribe <i
                            className="fal fa-paper-plane"></i></button>
                        </form>
                      </div>
                    </div>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
          {/* <!-- main footer end  --> */}
        </div>
      </div>

      {/* <!-- footer copy right --> */}
      <div className="top-footer-copyright pt-20 black-bg">
        <div className="container">
          <div className="row">
            <div className="col-md-8 col-12">
              <div className="tp-copyrigh-text mb-20">
                <div>{`"${t('slogan_3')}"`}</div>
                <span>© {new Date().getFullYear()} ONCE IN MEMORY</span>
              </div>
            </div>
            {agent && agent?.code && <div className="col-md-4 col-12">
              <div className="text-md-end mb-30 ">
                <div className="text-white">{t('sale_agent')} : </div>
                <div className="text-white">{`[${agent?.code}] ${agent?.firstname} ${agent?.lastname}`}</div>
              </div>
              {/* <div className="tp-footer-social-icon mb-30 text-md-end">
                <ul>
                  <li><a href="#"><i className="fab fa-facebook"></i></a></li>
                  <li><a href="#"><i className="fab fa-tiktok"></i></a></li>
                  <li><a href="#"><i className="fab fa-instagram"></i></a></li>
                  <li><a href="#"><i className="fab fa-youtube"></i></a></li>
                  <li><a href="#"><i className="fab fa-twitter"></i></a></li>
                </ul>
              </div> */}
            </div>}
          </div>
        </div>
      </div>
      {/* <!-- footer copyright end  --> */}
    </footer>
  );
};

export default OnceFooter;
